export default __webpack_public_path__ + "static/media/logo.2a422637.png";